import FontAwesomeIcon from "./FontAwesomeIcon";

export default function TrashIcon({ ...props }) {
  return <FontAwesomeIcon name="trash" {...props} />;
}
